import './FiModalTopOne.scss';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiModalTopOne.html'),
    bindings: {

    },
})
export class FiModalTopOne {
    static $inject = [
        '$mdDialog',
    ];


    constructor(
        private $mdDialog: angular.material.IDialogService,
    ) {
        //
    }

    $onInit() {
        //
    }

    close() {
        this.$mdDialog.cancel();
    }

}